import Chocolat from 'chocolat';
const chocolatParentSelector = window.chocolatParentSelector || '.chocolat-parent';
const chocolatChildSelector = window.chocolatChildSelector || '.chocolat-image';

// decides on wether to group images or not
// not grpouping will result in a single gallery for the whole page
// grouping will result in multiple galleries, one for each brick practically
const grouped = window.grouped || false;

const wholePageImageEls = document.querySelectorAll(`${chocolatParentSelector} ${chocolatChildSelector}`); 
const groupImageEls = document.querySelectorAll(`${chocolatParentSelector}`); 

try {
    if (grouped) {
        groupImageEls.forEach((groupImageEl) => {
            const imageEls = groupImageEl.querySelectorAll(chocolatChildSelector);
            Chocolat(imageEls, {});
        });
    } else {
        Chocolat(wholePageImageEls, {});
    }
} catch (error) {
  console.log(error);
}
